export const RELEASE_NOTES_PER_PAGE = 20;
export const BLOGS_PER_PAGE = 12;

export const BRAND_CODE_GP = "gp";
export const BRAND_CODE_SG = "sg";
export const BRAND_CODE_GN = "gn";
export const BRAND_CODE_OM = "om";
export const BRAND_CODE_LA = "la";
export const PUBLISHED = "Live";
export const GUIDE_TYPES = {
	Guide: "guide",
	Tutorial: "tutorial",
};

export const BRAND_NAMES = {
	om: "OMIQ",
	sg: "Snapgene",
	gp: "Graphpad",
	gn: "Geneious",
	la: "LabArchives",
};
